import { CategoryGrid, BrandGrid, Hero, ProductGrid, WhyChoose } from "@/components";
import { SectionHeader } from "@/components";
import { fetchAllBrandsQueryOptions } from "@/queryOptions/brands/fetchPaginatedBrands";
import { fetchAllCategoriesQueryOptions } from "@/queryOptions/categories/fetchPaginatedCategories";
import { fetchCustomPaginatedProductsQueryOptions } from "@/queryOptions/products/fetchCustomPaginatedProducts";
import { useAppSelector } from "@/store/hooks";
import {} from "@/store/slices/appSlice";
import { getDefaultParseVariants } from "@/utils/helper/getDefaultParseVariants";
import { useInfiniteQuery, useQuery } from "@tanstack/react-query";
import React, { useMemo } from "react";

const Home: React.FC = () => {
   const { brands, categories, productsForDisplay, productsLoading, categoriesLoading, brandsLoading } = useAppSelector((state) => state.app);

  // const { data: brands, isLoading: brandsLoading } = useQuery(
  //   fetchAllBrandsQueryOptions(
  //     {},
  //     {
  //       enabled: true,
  //     }
  //   )
  // );

  // const { data: categories, isLoading: categoriesLoading } = useQuery(
  //   fetchAllCategoriesQueryOptions(
  //     {},
  //     {
  //       enabled: true,
  //       staleTime: 1000 * 60 * 5,
  //     }
  //   )
  // );

  // const { data: products, isLoading: productsLoading } = useInfiniteQuery(
  //   fetchCustomPaginatedProductsQueryOptions({}, 10, {
  //     staleTime: 1000 * 60 * 5,
  //     enabled: true,
  //   })
  // );

  // const productsForDisplay = useMemo(() => {
  //   return getDefaultParseVariants(products?.pages?.flatMap((page) => page.items) || []);
  // }, [products]);

  return (
    <div className="min-h-screen overflow-x-hidden">
      <Hero />

      <BrandGrid
        gridItems={brands?.slice(0, 8)}
        loading={brandsLoading}
        skeletonCount={8}
        sectionHeader={
          <SectionHeader heading="Brands" rightLinkText="View All" rightLink="/brands" />
        }
      />

      <CategoryGrid
        isCategory={true}
        loading={categoriesLoading}
        skeletonCount={8}
        gridItems={categories?.slice(0, 8)}
        sectionHeader={
          <SectionHeader heading="Categories" rightLinkText="View All" rightLink="/categories" />
        }
      />

      <ProductGrid
        gridItems={productsForDisplay?.slice(0, 9)}
        className="lg:grid-cols-3 px-6"
        sectionHeader={
          <SectionHeader heading="Products" rightLinkText="View All" rightLink="/products" />
        }
        loading={productsLoading}
        skeletonCount={6}
      />
      <WhyChoose />
    </div>
  );
};

export default Home;
